import { Header } from './containers'
import { Stack } from '@mui/system'
import { TabPanels } from './containers/TabPanels'
import { Container, Wrapper, Content } from './styles'
import { TabSelector } from './containers/TabSelector'

export default function MonitorView() {
  return (
    <Container>
      <Wrapper direction="column">
        <Header />

        <Stack direction="row" gap={4} flexWrap="wrap" width="100%">
          <TabSelector />
        </Stack>

        <Content>
          <TabPanels />
        </Content>
      </Wrapper>
    </Container>
  )
}
